import { feedTopics } from '@/mocks/home';

type TopicFilterProps = {
  activeTopic: string;
  onChange: (topic: string) => void;
};

export default function TopicFilter({ activeTopic, onChange }: TopicFilterProps) {
  return (
    <div className="no-scrollbar -mx-1 flex w-full items-center gap-2 overflow-x-auto px-1 py-1">
      {feedTopics.map((topic) => {
        const active = topic === activeTopic;
        return (
          <button
            key={topic}
            type="button"
            onClick={() => onChange(topic)}
            className={`flex h-8 shrink-0 items-center whitespace-nowrap rounded-full px-3.5 font-label text-xs transition-colors ${
              active
                ? 'bg-foreground-950 font-medium text-background-50'
                : 'border border-background-200 bg-background-100 text-foreground-700 hover:text-foreground-950'
            }`}
          >
            {topic}
          </button>
        );
      })}
    </div>
  );
}